// src/slices/flightFilterSlice.js



import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    filteredDataRoundTrip: null,
    selectedStops: "",
    selectedReturnStops: "",
    selectedVenderTypeOnward: "",
    selectedVenderTypeReturn: "",
    selectedDeparture: [],
    selectedReturnDate: [],
    selectedAirlines: [],
    selectedReturnAirlines: [],
    priceRange: [0, 100],
    returnPriceRange: [0, 100],
    defaultPriceRange: [0, 100],
    defaultReturnPriceRange: [0, 100],
    sortBy: "",
    sortByReturn: ""
};

const flightRoundTripFilterSlice = createSlice({
    name: 'flightFilterRoundTrip',
    initialState,
    reducers: {
        setFilteredDatafilteredData(state, action) {
            state.filteredDataRoundTrip = action.payload;
        },
        setSelectedStops(state, action) {
            state.selectedStops = action.payload;
        },

        setSelectedVenderTypeOnward(state, action) {
            state.selectedVenderTypeOnward = action.payload;
        },
        setSelectedVenderTypeReturn(state, action) {
            state.selectedVenderTypeReturn = action.payload;
        },
        setSortBy(state, action) {
            state.sortBy = action.payload;
        },
        setSortByReturn(state, action) {
            state.sortByReturn = action.payload;
        },
        setSelectedReturnStops(state, action) {
            state.selectedReturnStops = action.payload;
        },
        setSelectedDeparture(state, action) {
            state.selectedDeparture = action.payload;
        },
        setSelectedReturnDate(state, action) {
            state.selectedReturnDate = action.payload;
        },
        setSelectedAirlines(state, action) {
            state.selectedAirlines = action.payload;
        },
        setSelectedReturnAirlines(state, action) {
            state.selectedReturnAirlines = action.payload;
        },
        setPriceRange(state, action) {
            state.priceRange = action.payload;
        },
        setReturnPriceRange(state, action) {
            state.returnPriceRange = action.payload;
        },
        setDefaultPriceRange(state, action) {
            state.defaultPriceRange = action.payload;
        },
        setDefaultReturnPriceRange(state, action) {
            state.defaultReturnPriceRange = action.payload;
        },

        clearAllFiltersRoundTrip(state, action) {

            const { roundCityFlightFilterData } = action.payload;
            const { filteredReturnFlights } = action.payload;
            const minPrice = roundCityFlightFilterData?.priceRange?.minPrice || 0;
            const maxPrice = roundCityFlightFilterData?.priceRange?.maxPrice || 100;
            const returnMinPrice = roundCityFlightFilterData?.returnPriceRange?.minPrice || 0;
            const returnMaxPrice = roundCityFlightFilterData?.returnPriceRange?.maxPrice || 100;
        
            state.selectedStops = '';
            state.selectedReturnStops = '';
            state.selectedVenderTypeOnward = '';
            state.selectedVenderTypeReturn = '';
            state.sortBy = "";
            state.sortByReturn = "";
            state.selectedDeparture = [];
            state.selectedReturnDate = [];
            state.selectedAirlines = [];
            state.selectedReturnAirlines = [];
            state.priceRange = [minPrice, maxPrice];
            state.returnPriceRange = [returnMinPrice, returnMaxPrice];
            state.filteredDataRoundTrip = { ...roundCityFlightFilterData };
        },
        applyFilters(state, action) {
            const { roundCityFlightFilterData } = action.payload;
            if (!roundCityFlightFilterData) return;

            let filteredFlights = roundCityFlightFilterData?.results?.flights;
            let filteredReturnFlights = roundCityFlightFilterData?.results?.returnFlights || [];

            const {
                selectedStops,
                selectedReturnStops,
                selectedDeparture,
                selectedReturnDate,
                selectedAirlines,
                selectedVenderTypeOnward,
                selectedVenderTypeReturn,
                selectedReturnAirlines,
                priceRange,
                returnPriceRange,
                sortBy,
                sortByReturn
            } = state;

            const timeRanges = {
                before_6AM: { start: 0, end: 6 },
                after6AM_12PM: { start: 6, end: 12 },
                after12PM_6PM: { start: 12, end: 18 },
                after_6PM: { start: 18, end: 24 },
            };

            // Filter departure flights by stops
            if (selectedStops.length > 0) {
                filteredFlights = filteredFlights.filter((flight) => {
                    return selectedStops.includes(flight.stops?.toString());
                });
            }

            if (selectedReturnStops.length > 0) {
                filteredReturnFlights = filteredReturnFlights.filter((flight) =>
                    selectedReturnStops.includes(flight.stops?.toString())
                );
            }

            // Filter onward flights by selected vendor type
            if (selectedVenderTypeOnward) {
                filteredFlights = filteredFlights.filter((flight) =>
                    flight.vendor === selectedVenderTypeOnward
                );
            }

            // Filter return flights by selected vendor type
            if (selectedVenderTypeReturn) {
                filteredReturnFlights = filteredReturnFlights.filter((flight) =>
                    flight.vendor === selectedVenderTypeReturn
                );
            }

            // Filter departure flights by departure time
            if (selectedDeparture.length > 0) {
                filteredFlights = filteredFlights.filter((flight) => {
                    const departureTime = new Date(flight.departureTime).getHours();
                    return selectedDeparture.some((time) => {
                        const range = timeRanges[time];
                        return departureTime >= range.start && departureTime < range.end;
                    });
                });
            }

            // Filter return flights by return date time
            if (selectedReturnDate.length > 0) {
                filteredReturnFlights = filteredReturnFlights.filter((flight) => {
                    const returnTime = new Date(flight.departureTime).getHours();
                    return selectedReturnDate.some((time) => {
                        const range = timeRanges[time];
                        return returnTime >= range.start && returnTime < range.end;
                    });
                });
            }

            // Filter departure flights by preferred airlines
            if (selectedAirlines.length > 0) {
                filteredFlights = filteredFlights.filter((flight) =>
                    selectedAirlines.includes(flight.airline)
                );
            }

            // Filter return flights by preferred airlines
            if (selectedReturnAirlines.length > 0) {
                filteredReturnFlights = filteredReturnFlights.filter((flight) =>
                    selectedReturnAirlines.includes(flight.airline)
                );
            }

            // Filter departure flights by price range
            filteredFlights = filteredFlights?.filter((flight) => {
                const totalPrice = flight.priceOptions[0]?.totalFare;
                return totalPrice >= priceRange[0] && totalPrice <= priceRange[1];
            });

            // Filter return flights by price range
            filteredReturnFlights = filteredReturnFlights.filter((flight) => {
                const totalPrice = flight.priceOptions[0]?.totalFare;
                return totalPrice >= returnPriceRange[0] && totalPrice <= returnPriceRange[1];
            });

            if (sortBy === "cheapest") {
                // filteredFlights.sort((a, b) => b.priceOptions[0]?.baseFare - a.priceOptions[0]?.baseFare);
            } else if (sortBy === "fastest") {
                filteredFlights?.sort((a, b) => a.total_duration - b.total_duration);
            }

            if (sortByReturn === "cheapestReturn") {
                filteredReturnFlights?.sort((a, b) =>
                    (a.priceOptions[0]?.baseFare || 0) - (b.priceOptions[0]?.baseFare || 0)
                );
            } else if (sortByReturn === "fastestReturn") {
                filteredReturnFlights?.sort((a, b) => (a.total_duration || 0) - (b.total_duration || 0));
            }

            state.filteredDataRoundTrip = {
                ...roundCityFlightFilterData,
                flights: filteredFlights,
                returnFlights: filteredReturnFlights
            };
        },

    },
});


export const {
    setFilteredDatafilteredData,
    setSelectedStops,
    setSelectedReturnStops,
    setSelectedDeparture,
    setSelectedReturnDate,
    setSelectedAirlines,
    setSelectedReturnAirlines,
    setPriceRange,
    setSelectedVenderTypeOnward,
    setSelectedVenderTypeReturn,
    setReturnPriceRange,
    setDefaultPriceRange,
    setDefaultReturnPriceRange,
    clearAllFiltersRoundTrip,
    setSortBy,
    setSortByReturn,
    applyFilters,
} = flightRoundTripFilterSlice.actions;

export default flightRoundTripFilterSlice.reducer;


